import { Injectable, inject } from '@angular/core';
import { DataContextService } from '@seahorse/common';
import { NoteModel } from '../models/note.model';

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  private _dataContext = inject(DataContextService);

  get(objectId: string, objectType: string) {
    return this._dataContext.get<NoteModel[]>(
      `notes/${objectId}/${objectType}`
    );
  }

  add(note: NoteModel) {
    return this._dataContext.post<NoteModel>('notes', note);
  }

  update(note: NoteModel) {
    return this._dataContext.put<NoteModel>(`notes/${note.id}`, note);
  }

  delete(id: number) {
    return this._dataContext.delete<NoteModel>(`notes/${id}`);
  }
}
